module.exports = __webpack_public_path__ + "static/img/jz.d1d3262.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/jz.gif
// module id = bJlk
// module chunks = 5